//#region auth
export const AUTH_SIGNIN = "/api/auth/sign-in";
export const AUTH_FORGOT_PASSWORD = "/api/auth/forget-password";
export const AUTH_RESET_PASSWORD = "/api/auth/reset-password";
//#endregion

//#region profile
export const USER_GET_PROFILE = "/api/user/profile";
export const USER_UPDATE_PROFILE = "/api/user/profile";
export const USER_CHANGE_PASSWORD = "/api/user/password/change";
export const UPDATE_PROFILE_AVATAR = "/api/user/avatar/update";

//#endregion

//#region Customers
export const GET_CUSTOMERS = (data) =>
  GeneratePaginationURL(data, "/api/user/customer");
export const ADD_CUSTOMER = "/api/user/customer";
export const GET_CUSTOMER = (id) => `/api/user/get-by-id/${id}`;
export const UPDATE_CUSTOMER = (id) => `/api/user/${id}/update`;
export const DELETE_USER = (id) => `/api/user/${id}`;
//#endregion

//#region Technicians
export const GET_TECHNICIANS = (data) =>
  GeneratePaginationURL(data, "/api/user/technician");
export const ADD_TECHNICIAN = "/api/user/technician";
export const GET_TECHNICIAN = (id) => `/api/user/get-by-id/${id}`;
export const UPDATE_TECHNICIAN = (id) => `/api/user/${id}/update`;
export const UPDATE_BLOCK_STATUS = (id) =>
  `/api/user/technician/${id}/block-unblock`;

//#endregion

//#region Categories
export const GET_CATEGORIES = (data) =>
  GeneratePaginationURL(data, "/api/category");
export const ADD_CATEGORY = "/api/category";
export const GET_CATEGORY = (id) => `/api/category/${id}`;
export const UPDATE_CATEGORY = (id) => `/api/category/${id}`;
export const DELETE_CATEGORY = (id) => `/api/category/${id}`;
export const UPLOAD_CATEGORY_ICON = `/api/files/CATEGORY_ICON`;
export const GET_CATEGORIES_SELECT_LIST = "/api/category/select/list";
export const GET_TECHNICIAN_PURCHASES = (id) =>
  `/api/category/technician/${id}/purchases`;
export const CHANGE_TECHNICIAN_REMAINING_CALLS = `/api/purchase/change-remaining-calls`;

//#endregion

//#region Services
export const GET_SERVICES = (data) =>
  GeneratePaginationURL(data, "/api/service");
export const ADD_SERVICE = "/api/service";
export const GET_SERVICE = (id) => `/api/service/${id}`;
export const UPDATE_SERVICE = (id) => `/api/service/${id}`;
export const DELETE_SERVICE = (id) => `/api/service/${id}`;
export const UPLOAD_SERVICE_ICON = `/api/files/SERVICE_ICON`;

//#endregion

//#region Governorates
export const GET_GOVERNORATES = (data) =>
  GeneratePaginationURL(data, "/api/governorate");
export const ADD_GOVERNORATE = "/api/governorate";
export const GET_GOVERNORATE = (id) => `/api/governorate/${id}`;
export const UPDATE_GOVERNORATE = (id) => `/api/governorate/${id}`;
export const DELETE_GOVERNORATE = (id) => `/api/governorate/${id}`;
export const GET_GOVERNORATES_SELECT_LIST = `api/governorate/select/list`;

//#endregion

//#region Cities
export const GET_CITIES = (data) => GeneratePaginationURL(data, "/api/city");
export const ADD_CITY = "/api/city";
export const GET_CITY = (id) => `/api/city/${id}`;
export const UPDATE_CITY = (id) => `/api/city/${id}`;
export const DELETE_CITY = (id) => `/api/city/${id}`;

//#endregion

//#region Notifications
export const SEND_NOTIFICATION = ({ role }) => `/api/notification?role=${role}`;
export const SEND_NOTIFICATION_V2 = () => `/api/notification/v2`;

//#endregion

//#region Notifications
export const GET_DASHBOARD_DATA = `/api/reports/dashboard`;

//#endregion

//#region Common
const GeneratePaginationURL = (data, url) => {
  if (data?.page) {
    url += `?page=${data.page}`;
  } else {
    url += `?page=${1}`;
  }
  if (data?.limit && data?.limit > 0) {
    url += `&limit=${data.limit}`;
  } else {
    url += `&limit=${10}`;
  }
  if (data?.sortBy && data?.sortDirection) {
    url += `&sortBy=${data.sortBy}:${data.sortDirection}`;
  }
  if (data?.search && data?.search !== "") {
    url += `&search=${data.search}`;
  }
  if (data?.categoryId && data?.categoryId !== "") {
    url += `&filter[categoryId]=${data.categoryId}`;
  }
  if (data?.customerId && data?.customerId !== "") {
    url += `&filter[customerId]=${data.customerId}`;
  }
  if (data?.hasPurchased && data?.hasPurchased !== "") {
    url += `&filter[hasPurchased]=${data.hasPurchased}`;
  }
  return url;
};
//#endregion

//#region Ads
export const GET_ADS = (data) => GeneratePaginationURL(data, "/api/ad");
export const ADD_AD = "/api/ad";
export const GET_AD = (id) => `/api/ad/${id}`;
export const UPDATE_AD = (id) => `/api/ad/${id}`;
export const DELETE_AD = (id) => `/api/ad/${id}`;
export const UPLOAD_AD_BANNER = "/api/files/upload/banner";

//#endregion

//#region Complains
export const GET_COMPLAINS = (data) =>
  GeneratePaginationURL(data, "/api/complaint");
export const GET_COMPLAIN = (id) => `/api/complaint/${id}`;
export const SEND_COMPLAIN_REPLY = (id) => `/api/complaint/${id}/reply`;

//#endregion

//#region Orders
export const GET_ORDERS = (data) => GeneratePaginationURL(data, "/api/order");
export const GET_ORDER = (id) => `/api/order/${id}`;
export const GET_ORDER_HISTORY = (id) => `/api/order/${id}/history`;

//#endregion

//#region Policies
export const GET_POLICIES = (data) =>
  GeneratePaginationURL(data, "/api/privacy-policy");
export const ADD_POLICY = "/api/privacy-policy";
export const GET_POLICY = (id) => `/api/privacy-policy/${id}`;
export const UPDATE_POLICY = (id) => `/api/privacy-policy/${id}`;
export const DELETE_POLICY = (id) => `/api/privacy-policy/${id}`;
export const GET_DEFAULT_POLICY = () => `/api/privacy-policy/default/policy`;
export const CONTACT_US = "/api/privacy-policy/support/contact";
export const DELETE_ACCOUNT_REQUEST =
  "/api/privacy-policy/delete-account-request";

//#endregion

//#region Settings

export const GET_SETTINGS = (id) => `/api/configuration`;
export const UPDATE_SETTINGS = (id) => `/api/configuration`;

//#endregion

//#region dashboard
export const GET_DASHBOARD = (data) =>
  `/api/dashboard/stats?from=${data.from}&to=${data.to}`;
//#endregion

//#region subscriptions
export const GET_SUBSCRIPTIONS = (data) =>
  GeneratePaginationURL(data, "/api/subscription");
export const GET_SUBSCRIPTION = (id) => `/api/subscription/${id}`;
export const UPDATE_SUBSCRIPTION = (data) =>
  `/api/subscription/${data.subscriptionId}/change-expiration/${data.days}`;
//#endregion
